;<template>
  <svg viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="1.25"
      y="0.75"
      width="10.5"
      height="10.5"
      rx="1"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.34064 3.64258V8.35765H3.34375V3.64258H4.34064Z"
      fill="currentColor"
    />
    <path
      d="M7.35094 8.35765H5.67949V3.64258H7.36476C7.83903 3.64258 8.2473 3.73697 8.58957 3.92576C8.93184 4.11301 9.19507 4.38238 9.37925 4.73386C9.56497 5.08534 9.65783 5.50589 9.65783 5.99551C9.65783 6.48666 9.56497 6.90875 9.37925 7.26177C9.19507 7.61478 8.93031 7.88568 8.58497 8.07447C8.24116 8.26326 7.82982 8.35765 7.35094 8.35765ZM6.67637 7.50351H7.3095C7.60419 7.50351 7.85207 7.45132 8.05314 7.34695C8.25574 7.24105 8.40769 7.07758 8.50899 6.85656C8.61183 6.63401 8.66324 6.34699 8.66324 5.99551C8.66324 5.6471 8.61183 5.36238 8.50899 5.14136C8.40769 4.92035 8.25651 4.75765 8.05544 4.65328C7.85437 4.54891 7.6065 4.49673 7.3118 4.49673H6.67637V7.50351Z"
      fill="currentColor"
    />
    <path
      d="M4.34064 3.64258V8.35765H3.34375V3.64258H4.34064Z"
      stroke="currentColor"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.35094 8.35765H5.67949V3.64258H7.36476C7.83903 3.64258 8.2473 3.73697 8.58957 3.92576C8.93184 4.11301 9.19507 4.38238 9.37925 4.73386C9.56497 5.08534 9.65783 5.50589 9.65783 5.99551C9.65783 6.48666 9.56497 6.90875 9.37925 7.26177C9.19507 7.61478 8.93031 7.88568 8.58497 8.07447C8.24116 8.26326 7.82982 8.35765 7.35094 8.35765ZM6.67637 7.50351H7.3095C7.60419 7.50351 7.85207 7.45132 8.05314 7.34695C8.25574 7.24105 8.40769 7.07758 8.50899 6.85656C8.61183 6.63401 8.66324 6.34699 8.66324 5.99551C8.66324 5.6471 8.61183 5.36238 8.50899 5.14136C8.40769 4.92035 8.25651 4.75765 8.05544 4.65328C7.85437 4.54891 7.6065 4.49673 7.3118 4.49673H6.67637V7.50351Z"
      stroke="currentColor"
      stroke-width="0.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
